module.exports = __webpack_public_path__ + "img/secure_email.88448a3d.svg";